import React from 'react';

function Standings({ leagueData, teams }) {
    return (
        <div className="standings">
            <h3>Standings Component</h3>
            <p>League: {leagueData?.name || 'Sample League'}</p>
            <p>Teams: {teams?.length || 0}</p>
            {/* Phase 2: Add actual standings functionality */}
        </div>
    );
}

export default Standings;